import { AppModal } from '@/shared/ui'
import { FunctionComponent } from 'react'
export type GroupFlagsProps = {
  isVisible: boolean
  userGroup: string
  innerContent: any
  translate: (arg0: string) => string
  toClose: () => void
}

export const GroupFlagsModal: FunctionComponent<GroupFlagsProps> = ({
  isVisible = false,
  userGroup = '',
  translate = (arg0: string) => '',
  toClose = () => {},
  innerContent = ''
}: GroupFlagsProps): JSX.Element => {
  return (
    <AppModal
      title={translate('user-profile.alerts-assigned-to-your-group') + ' - ' + userGroup}
      open={isVisible}
      onCancel={toClose}
      centered={true}
      footer={null}
      keyboard={true}
      maskClosable={true}
      width={1200}
      closable={true}
    >
      {innerContent}
    </AppModal>
  )
}
